<template>
  <div id="indexrenew">
    <div style="text-align: center;padding-top: 10%">
      <span class="text_4d">查询/续借</span>
    </div>
    <div class="section_2d flex-col" >
      <div class="text-wrapper_2d flex-row">
        <div style="width: 21%;height: 22px;margin: 15px 0 0 4%;"><span class="text_5d">书名</span></div>
        <div style="width: 19%;height: 22px;margin: 15px 0 0 0;"><span class="text_6d">条码</span></div>
        <div style="width: 24%;height: 22px;margin: 15px 0 0 0;"><span class="text_7d">还书日期</span></div>
        <div style="width: 20%;height: 22px;margin: 15px 0 0 0;"><span class="text_7d">状态信息</span></div>
      </div>
      <div id="renewbookscontent">
        <div class="text-wrapper_3d flex-row" v-for="(item,index) in books" :key="item.StrID" >
          <div style="width: 23%;height: 47px;display: flex;">
            <p class="text_9d" style="margin: 0;display: flex;align-items: center;"
               v-if="item.StrPositiveTitle.length<12">{{ item.StrPositiveTitle }}</p>
            <p class="text_9d" style="margin: 0;display: flex;align-items: center;" v-else>
              {{ item.StrPositiveTitle.substring(0, 12) }}...</p>
          </div>
          <div style="width: 20%;height: 47px;"><span class="text_8d">{{ item.StrBookBarcode }}</span></div>
          <div style="width: 24%;height: 47px;"><span class="text_8d">{{ item.DTReturnDate.substring(0, 10) }}</span>
          </div>

          <div style="width: 20%;height: 47px;display: flex;">
            <p class="text_9d" style="margin: 0;display: flex;align-items: center;width: 100%"
               v-if="item.StrReaderName.length<13">{{ item.StrReaderName }}</p>
            <p class="text_9d" style="margin: 0;display: flex;align-items: center;width: 100%" v-else>
              {{ item.StrReaderName.substring(0, 13) }}...</p>
          </div>

          <div style="height: 47px;" @click="clickitem(index,item.StrType)" v-if="item.StrType==='false'">
            <img src="../assets/img/icon/choosebackup.svg" style="width: 30px;height: 30px;margin-top: 8.5px;">
          </div>
          <div style="height: 47px;" @click="clickitem(index,item.StrType)" v-else-if="item.StrType==='true'">
            <img src="../assets/img/icon/choose.svg" style="width: 30px;height: 30px;margin-top: 8.5px;">
          </div>
          <div style="height: 47px;" v-else-if="item.StrType==='noshow'"></div>
        </div>
        <div style="height: 37px;font-size: 12px;margin: auto;color: #C0C4CC;text-align: center;line-height: 37px"
             v-show="nodata">
          暂无数据
        </div>
        <div style="height: 37px;font-size: 12px;margin: auto;color: #C0C4CC;text-align: center;line-height: 37px"
             v-show="loading">
          加载中...
        </div>
      </div>
    </div>
    <button class="button_1d flex-col" @click="renew" v-if="canrenewbook">
      <!--      续借-->
      <div class="text_18d">续借</div>
    </button>

    <button class="button_1dw flex-col" v-else>
      <!--      续借-->
      <div class="text_18dw">续借</div>
    </button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'findorrenew',
  data () {
    return {
      books: [],
      barCodes: {
        'bookBarCodes': []
      },
      canrenewbook: false,
      nodata: false,
      loading: true
    }
  },
  mounted () {
    //10% 33px 6%*90% 52px 51px 8%(父元素高度)  w15.4 h8 136
    document.getElementById('indexrenew').style.height = document.body.clientHeight + 'px';
    document.getElementById('renewbookscontent').style.maxHeight = (document.body.clientHeight * 0.92) -(document.body.clientWidth * 0.22)  - 136 + 'px';
    this.getbooks()
  },
  methods: {
    clickitem (index, is) {
      if (is === 'true') {
        this.books[index].StrType = 'false'
      } else if (is === 'false') {
        this.books[index].StrType = 'true'
      }

      var i
      for (i in this.books) {
        if (this.books[i].StrType === 'true') {
          this.canrenewbook = true
          return
        }
      }
      this.canrenewbook = false
    },
    getbooks () {
      axios({
        method: 'POST',
        url: process.env.VUE_APP_BASE_URL+'/sanyue/currentBorrow',
        //发送格式为json
        headers:
          {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem('token')
          }
      }).then(response => {
        if (response.code === 0) {
          this.books = response.msg
          var index
          for (index in this.books) {
            //StrReaderName 被用来标记状态信息了
            this.books[index].StrReaderName = ''
            this.books[index].StrType = 'false'
          }
          if(this.books.length === 0){
            this.nodata = true
          }
          this.loading = false
          // document.getElementById('libitems').setAttribute('max-length', 3 * 51 +'px')
        }else {
          alert(response.msg)
        }
      })
    },
    renew () {
      this.barCodes.bookBarCodes = []
      let index
      for (index in this.books) {
        if (this.books[index].StrType === 'true') {
          this.barCodes.bookBarCodes.push(this.books[index].StrBookBarcode)
        }
      }
      axios({
        method: 'POST',
        url:process.env.VUE_APP_BASE_URL+'/sanyue/continueborrowbook',
        data: JSON.stringify(this.barCodes),
        //发送格式为json
        headers:
          {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem('token')
          }
      }).then(response => {
        if (response.code === 0) {
          // this.$notify({
          //   title: '成功',
          //   message: '续借成功',
          //   type: 'success',
          //   duration: 2000
          // })
          var allsuccess = true
          var index, bookindex
          for (index in response.msg) {
            for (bookindex in this.books) {
              if (response.msg[index].bookBarCode === this.books[bookindex].StrBookBarcode) {
                if (response.msg[index].success) {
                  this.books[bookindex].StrReaderName = '续借成功'
                  this.books[bookindex].StrType = 'noshow'
                  var date = new Date(response.msg[index].msg * 1000);  // 参数需要毫秒数，所以这里将秒数乘于 1000
                  var Y = date.getFullYear() + '-';
                  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                  var D = date.getDate() + '';
                  this.books[bookindex].DTReturnDate = Y+M+D
                } else {
                  this.books[bookindex].StrReaderName = response.msg[index].msg
                  //将全部都不选
                  this.books[bookindex].StrType = 'false'
                  allsuccess = false
                }
              }
            }
          }
          this.canrenewbook = false
          //都续借成功
          if (allsuccess) {
            this.$notify({
              title: '成功',
              message: '续借成功',
              type: 'success',
              duration: 2000
            })
          }
          // document.getElementById('libitems').setAttribute('max-length', 3 * 51 +'px')
        } else {
          this.$notify.error({
            title: '错误',
            message: '续借失败,' + response.msg.msg,
            duration: 2000
          })
        }
      })
    },
  },
}
</script>

<style scoped>
#renewbookscontent{
  overflow-y: auto;
  overflow-x: hidden
}
#indexrenew {
  background-image: url(../assets/img/bg.png);
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}

/*超出长度显示省略号*/
.ellipsis {
  white-space: nowrap; /*内容超宽后禁止换行显示*/
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*文字超出部分以省略号显示*/
}

.text_4d {
  width: 96px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(7, 7, 7, 1);
  font-size: 24px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 33px;
}

.section_2d {
  background-color: rgba(255, 255, 255, 1);
  /*border-radius: 0 0 12px 12px;*/
  border-radius: 12px;
  position: relative;
  width: 90%;
  margin: 6% 0 0 5%;
}

.text-wrapper_2d {
  background-color: rgba(237, 242, 255, 1);
  border-radius: 12px 12px 0px 0px;
  width: 100%;
  height: 52px;
  /*margin: 6% 0 0 5%;*/
  /*justify-content: flex-center;*/
}

.text_5d {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;


}

.text_6d {

  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}

.text_7d {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}

.text-wrapper_3d {
  width: 100%;
  height: 47px;
  margin-left: 2%;
}

.text_8d {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 47px;
}

.text_9d {
  color: rgba(0, 0, 0, 1);
  font-size: 11px;
  text-align: left;
  /*margin: 0;*/
  width: 90%;
  overflow: hidden;
  line-height: 12px;
  word-break: break-all;
  word-wrap: break-word;
  margin: 0;
}

.button_1d {
  background-color: rgba(0, 94, 255, 0.1);
  border-radius: 8px;
  height: 51px;
  width: 90%;
  margin: 0 0 0 5%;
  position: absolute;
  bottom: 8%;
}

.text_18d {
  color: rgba(0, 94, 255, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  white-space: nowrap;
  line-height: 22px;
  margin-top: 15px;

  position: absolute;
  right: 50%;
  bottom: 50%;
  transform: translateX(50%) translateY(50%);
}

.button_1dw {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  height: 51px;
  width: 90%;
  margin: 0 0 0 5%;
  position: absolute;

  bottom: 8%;
}

.text_18dw {
  color: rgba(102, 102, 102, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  white-space: nowrap;
  line-height: 22px;
  margin-top: 15px;

  position: absolute;
  right: 50%;
  bottom: 50%;
  transform: translateX(50%) translateY(50%);
}
</style>
